module.exports = __webpack_public_path__ + "img/filter-black.9e1e116.svg?v=1763034624171";